import axios, { AxiosError } from 'axios';
import qs, { IStringifyOptions } from 'qs';

export function toQueryString(obj: Record<string, any>, options?: IStringifyOptions) {
  return qs.stringify(obj, {
    addQueryPrefix: true,
    skipNulls: true,
    indices: false,
    ...options,
  });
}

export function isRequestError<T = any>(error: unknown): error is AxiosError<T> {
  if (!error) return false;

  return axios.isAxiosError(error);
}

/** The request failed because the server couldn't be reached, not because it refused. */
export function isConnectionError(error: unknown): boolean {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true;
  return isRequestError(error) && !error.response;
}

export function isNotFoundError(error: unknown): boolean {
  return isRequestError(error) && error.response?.status === 404;
}
